<template>
  <v-btn
    small
    @click.prevent="$store.dispatch(action, { messages, resourceType })"
    :disabled="
      $store.state.loading || $store.state.medicating || !messages.length
    "
    class="ma-2"
    :loading="$store.state.medicating"
    :color="color"
    outlined
  >
    {{ label || action }}
  </v-btn>
</template>

<script>
export default {
  props: {
    action: { type: String },
    label: { type: String },
    color: { type: String },
    messages: { type: Array },
    resourceType: { type: String },
  },
};
</script>
